// services/campaign.service.ts

import {
  AddMediaProductsToCampaignParams,
  Campaign,
  CreateCampaignParams,
  DataCampaigns,
  TransferMediaProductParams,
} from "@/types/campaign";
import { environments } from "@/lib/config";
import { fetcher } from "@/lib/api/fetcher";
import { ResponseData } from "@/types/common";

const apiUrl = environments.restApiUrl;

// POST: Create Campaign
export const createCampaign = async ({
  campaign_name,
}: CreateCampaignParams): Promise<{
  data: { id?: number; campaign_id?: number | string; campaign_name: string };
}> => {
  const payload = {
    campaign_name,
  };

  const fullUrl = `${apiUrl}/campaigns/create`;

  return await fetcher(fullUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: payload,
  });
};

export interface GetCampaignsParams {
  page?: number;
  page_size?: number;
  campaign_name?: string;
  search_type?: "all" | "active" | "inactive";
  sort_order?: string;
}
// GET: Get list campaigns

export interface GetCampaignsParams {
  page?: number;
  page_size?: number;
  search_name?: string;
  sort_order?: string;
}
// GET: Get list campaigns
export const getCampaigns = async ({
  page = 1,
  page_size = 10,
  search_name,
  sort_order = "newest",
}: GetCampaignsParams): Promise<ResponseData<Campaign[]>> => {
  return await fetcher<ResponseData<Campaign[]>>(`${apiUrl}/campaigns/list`, {
    method: "GET",
    queryParams: {
      page,
      page_size,
      sort_order,
      ...(search_name ? { search_name } : {}),
    },
  });
};

// DELETE: campaigns
export const deleteCampaign = async (
  id: number
): Promise<{ success: boolean }> => {
  await fetcher(`${apiUrl}/campaigns/${id}`, {
    method: "DELETE",
  });

  return { success: true };
};

// PUT: rename campaigns

export const renameCampaign = async (id: number, newName: string) => {
  const params = new URLSearchParams({ campaign_name: newName }).toString();

  return await fetcher(`${apiUrl}/campaigns/${id}?${params}`, {
    method: "PATCH",
  });
};
// POST: duplicateCampaign
export const duplicateCampaign = async (id: number) => {
  return await fetcher(`${apiUrl}/campaigns/${id}/double`, {
    method: "POST",
  });
};

// DELETE: Media Product from Campaign
export const deleteMediaProductFromCampaign = async (
  campaignId: number,
  mediaProductId: number
): Promise<{ success: boolean }> => {
  await fetcher(
    `${apiUrl}/campaigns/${campaignId}/media-product/${mediaProductId}`,
    {
      method: "DELETE",
    }
  );

  return { success: true };
};

// POST: Move Mediaproduct in campaign
export const transferMediaProduct = async (
  params: TransferMediaProductParams
) => {
  return await fetcher(`${apiUrl}/campaigns/transfer-media-product`, {
    method: "POST",
    body: params,
  });
};
// POST: Add/Copy MediaProducts To Campaign
export const addMediaProductsToCampaign = async ({
  campaign_id,
  media_product_ids,
}: AddMediaProductsToCampaignParams) => {
  return await fetcher<ResponseData<DataCampaigns>>(
    `${apiUrl}/campaigns/add-media-product`,
    {
      method: "POST",
      body: {
        media_product_ids,
        campaign_id,
      },
    }
  );
};
